// src/pages/LoanBalance/index.js
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { DownloadOutlined, PrinterOutlined } from "@ant-design/icons";
import { App, Button, Card, Flex, Grid, Typography } from "antd";
import LoanBalanceFilters from "./components/LoanBalanceFilters";
import LoanBalanceTable from "./components/LoanBalanceTable";
import ReportDom from "../../../components/common/ReportDom";
import { useReactToPrint } from "react-to-print";
import { exportLoanBalanceCsv } from "./components/exportLoanBalanceCsv";

const { Title } = Typography;

const LoanBalance = () => {
  const { message } = App.useApp();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { filters, list, balanceTotal } = useSelector(
    (state) => state.loanBalance
  );

  const reportRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: reportRef,
    documentTitle: "Loan Balance Report",
    removeAfterPrint: true,
  });
  const handleDownloadCsv = () => {
    exportLoanBalanceCsv({
      list,
      balanceTotal,
      title:    "Loan Balance Report",
      filename: "loan_balance",
    });
  };

  const hasData = list.length > 0;
  return (
    <div className="p-4">
      <App>
        <Card
          className="shadow-md rounded-xl mb-4"
          title={<Title level={4} style={{ margin: 0 }} className="reportBigTitle">Loan Balance Report</Title>}
      extra={
            <Flex gap={8}>
              {hasData && (
                <Button icon={<DownloadOutlined />} onClick={handleDownloadCsv}>
                  {!screens.xs && "CSV"}
                </Button>
              )}
              <Button type="primary" icon={<PrinterOutlined />} onClick={handlePrint}>
                {!screens.xs && "Print"}
              </Button>
            </Flex>
          }
          styles={{
            header: { borderBottom: "none", padding: "12px 16px" },
            body: { padding: 0 },
          }}
        />

        <LoanBalanceFilters messageApi={message} />

        <Card className="shadow-md rounded-xl">
          <LoanBalanceTable />
        </Card>
      </App>

      {/* Hidden print layout */}
      <div style={{ position: "absolute", top: "-9999px", left: "-9999px" }}>
        <ReportDom
          ref={reportRef}
          title="Loan Balance Report"
          mode="report-page"
          filters={filters}
          renderTable={() => (
            <LoanBalanceTable pagination={false} printMode={true} />
          )}
        />
      </div>
    </div>
  );
};

export default LoanBalance;
